import React, { useState } from "react";
import Layout from "../../components/Layout/Layout";
import styles from "./CourierInfo.module.css";
import { Link } from "react-router-dom";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import Switch from "../../components/SwitchButton/SwitchButton";
import { useDispatch, useSelector } from "react-redux";
import { saveCourierInfoLocation } from "../../redux/actions/orderActions";

const CourierInfo = () => {
  const [type, setType] = useState("");
  const [weight, setWeight] = useState();
  const [isFragile, setIsFragile] = useState(false);
  const [details, setDetails] = useState("");

  const dispatch = useDispatch();

  const { pickupInfo } = useSelector((state) => state.savePickup);
  const { dropoffInfo } = useSelector((state) => state.saveDropoff);
  const { length } = useSelector((state) => state.saveLength);
  const { heigth } = useSelector((state) => state.saveHeigth);
  const { width } = useSelector((state) => state.saveWidth);

  const handleOnChange = (weight) => {
    setWeight(weight);
  };

  const handleCheckFragile = () => {
    setIsFragile(!isFragile);
  };

  const pic = pickupInfo?.address.coordinates;
  const dro = dropoffInfo?.address.coordinates;

  const rad = function (x) {
    return (x * Math.PI) / 180;
  };

  const getDistance = function (p1, p2) {
    const R = 6378137; // Earth’s mean radius in meter
    const dLat = rad(p2?.lat - p1?.lat);
    const dLong = rad(p2?.long - p1?.long);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(p1?.lat)) *
        Math.cos(rad(p2?.lat)) *
        Math.sin(dLong / 2) *
        Math.sin(dLong / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    return d; // returns the distance in meter
  };

  const distance = getDistance(pic, dro);
  const inKm = distance * 0.001;
  const consizeKm = `${inKm}`;
  const distanStrin = consizeKm.slice(0, 5);
  const payment = Number(distanStrin) * 1;

  const courierInfo = {
    isFragile: isFragile,
    type: type,
    details: details,
    weight: `${weight} Kg`,
    lwh: `${heigth} X ${width} X ${length}`,
    payment: payment,
    distance: distanStrin,
  };

  const saveCourierInfo = () => {
    dispatch(saveCourierInfoLocation(courierInfo));
  };

  const [background, setBackground] = useState("");
  const [color, setColor] = useState("");

  const saveButton = (value) => {
    setType(value);
    setBackground("#18254a");
    setColor("white");
  };

  return (
    <Layout title="Courier Info" route={"/drop-location"}>
      <div className={styles.container}>
        <p>Courier Type</p>
        <div className={styles.btnContainer}>
          <div>
            <button
              value="Envelop"
              style={{
                backgroundColor: type === "Envelope" && background,
                color: type === "Envelope" && color,
              }}
              onClick={() => saveButton("Envelope")}
            >
              Envelope
            </button>
          </div>
          <div>
            <button
              value="Box Pack"
              style={{
                backgroundColor: type === "Box Pack" && background,
                color: type === "Box Pack" && color,
              }}
              onClick={() => saveButton("Box Pack")}
            >
              Box Pack
            </button>
          </div>
          <div>
            <button
              value="Carton"
              style={{
                backgroundColor: type === "Carton" && background,
                color: type === "Carton" && color,
              }}
              onClick={() => saveButton("Carton")}
            >
              Carton
            </button>
          </div>
        </div>
        <div className={styles.dimensionsContainer}>
          <div className={styles.dimension}>
            <Link to="courier-measurement">
              <small>Height</small>
            </Link>
            <p>{heigth ? heigth : 0}</p>
          </div>
          <div className={styles.dimension}>
            <Link to="courier-measurement">
              <small>Width</small>
            </Link>
            <p>{width ? width : 0}</p>
          </div>
          <div className={styles.dimension}>
            <Link to="courier-measurement">
              <small>Length</small>
            </Link>
            <p>{length ? length : 0}</p>
          </div>
        </div>
        <div className={styles.weightContainer}>
          <div className={styles.weightHeader}>
            <p>Weight</p>
            <small>{weight} Kg</small>
          </div>
          <div className={styles.sliderContainer}>
            <Slider
              value={weight}
              orientation="horizontal"
              onChange={handleOnChange}
              labels={{ 0: "0kg", 100: "100kg" }}
            />
          </div>
        </div>
        <div className={styles.frangible}>
          <p>Frangible?</p>

          <div className="switch-container">
            <label>
              <input
                checked={isFragile}
                onChange={handleCheckFragile}
                className="switch"
                type="checkbox"
              />
              <div>
                <div></div>
              </div>
            </label>
          </div>

          {/* <Switch /> */}
        </div>
        <div className={styles.inputContainer}>
          <p>Courier detail</p>
          <textarea
            value={details}
            onChange={(e) => setDetails(e.target.value)}
            placeholder="Enter courier info"
          ></textarea>
        </div>
        <Link to="/confirm-info">
          <button onClick={saveCourierInfo} className={styles.continueBtn}>
            Continue{" "}
            <i className={styles.icon + " fas fa-long-arrow-alt-down"}></i>
          </button>
        </Link>
      </div>
    </Layout>
  );
};

export default CourierInfo;
